import { createApi } from "@reduxjs/toolkit/query/react";
import {
  CUSTOMER_GET_DATA,
  CUSTOMER_GET_DATA_NEW,
  CUSTOMER_GET_DATA_NODE,
  CUSTOMERTABLE_VALUE_UPDATE,
  CUSTOMERTABLE_VALUE_UPDATE_NODE,
  CUSTOMER_TABLEDROP_DATA,
  ADD_UPDATE_DROPDOWN,
  CUSTOMER_OTHERDETAIL_DYNAMIC_ADD_UPDATE,
  CUSTOMERTABLE_ADDFIELD_HEADERS,
  CUSTOMERTABLE_GETFIELD_HEADERS,
  BASE_URL,
  CUSTOMER_TABLEDYNAMIC_DROP,
  CUSTOMER_TABLEDYNAMIC_DROP_NODE,
  CUSTOMER_PERSON_IN_TABLE,
  CUSTOMERTABLE_UPDATEFIELD_HEADERS,
  RANDOM_PERSON,
  ADD_UPDATE_CUSTOMER_DELEGATION,
  DELETE_UPDATE_CUSTOMER_DELEGATION,
  ADD_CUSTOMER_DELEGATION,
  GET_PERMISSION_COMPANY,
  CUSTOMER_ALL_PERSON_IN_ORG,
  DELETE_CUSTOMER_DATA,
  UPDATE_CUSTOMER_DATA,
  DELETE_USER_CUSTOMERTABLE_REASONS_FETCH,
  DELETE_OR_ARCHIVE_USER_CUSTOMERTABLE,
  CUSTOMER_GET_DATA_NODE_TRACKING_PAGE,
} from "../constants";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";
import { getCompanyId, getUserToken } from "../utilityFunctions/localServices";
export const customerTableShowUpdate = createApi({
  reducerPath: "customerTableShowUpdate",
  baseQuery: customBaseQuery,
  tagTypes: ["CustomerTableData"],
  endpoints: (builder) => ({
    fetchAllCustomerValues: builder.query({
      query: ({ token, orgId, companyId, limit = 1000, viewName = "Default", type, isArchived }) => ({
        url: `${CUSTOMER_GET_DATA_NODE}?org_id=${orgId}&company_id=${companyId}&limit=${limit}&view_name=${viewName}&type=${type}&is_archived=${isArchived}`,
        method: "GET",

        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      providesTags: ["CustomerTableData"], // Adjust if needed
    }),
    fetchAllDeleteReasons: builder.query({
      query: ({ token }) => {
        return {
          url: `${DELETE_USER_CUSTOMERTABLE_REASONS_FETCH}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    fetchCustomerValuesTracking: builder.query({
      query: ({ token, params }) => {
        const queryParams = new URLSearchParams({
          ...params,
        }).toString();

        return {
          url: `${CUSTOMER_GET_DATA_NODE_TRACKING_PAGE}?${queryParams}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    updateDeleteOrArchive: builder.mutation({
      query: ({ token, payload }) => ({
        url: `${DELETE_OR_ARCHIVE_USER_CUSTOMERTABLE}`, // Endpoint URL
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload, // Sending data in the request body
      }),
    }),
    fetchCustomerTableData: builder.mutation({
      /* query: ({ token, companyId, owner, pagination, type = "ALL", customerPayload = {} }) => ({
        url: `${CUSTOMER_GET_DATA}${companyId}${pagination}&owner=${owner}&type=${type}`,
        method: "POST",
        body: JSON.stringify(customerPayload),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        providesTags: ["CustomerTableData"],
        // providesTags: (result, error, { companyId, pagination }) =>
        //   result ? [{ type: 'CustomerTableData', id: `${companyId}-${pagination}` }] : [],
      }), */
      query: ({ token, companyId, owner, pagination, type = "ALL", customerPayload = {} }) => {
        return {
          url: `${CUSTOMER_GET_DATA}${companyId}${pagination}&owner=${owner}&type=${type}`,
          method: "POST",
          body: JSON.stringify(customerPayload),
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          providesTags: ["CustomerTableData"],
        };
      },
    }),
    fetchCustomerTableDataNew: builder.mutation({
      query: ({ token, companyId, owner, pagination, type = "ALL", customerPayload = {} }) => {
        return {
          url: `${CUSTOMER_GET_DATA_NEW}${companyId}${pagination}&owner=${owner}&type=${type}`,
          method: "POST",
          body: JSON.stringify(customerPayload),
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          providesTags: ["CustomerTableDataNew"], // Different tag for cache invalidation if needed
        };
      },
    }),

    updateCustomerTableData: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMERTABLE_VALUE_UPDATE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
        invalidatesTags: ["CustomerTableData"],
        // invalidatesTags: (result, error, { data }) =>
        //   [{ type: 'CustomerTableData', id: `${data.companyId}-${data.pagination}` }],
      }),
    }),
    updateCustomerTableDataNode: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMERTABLE_VALUE_UPDATE_NODE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
        invalidatesTags: ["CustomerTableData"],
        // invalidatesTags: (result, error, { data }) =>
        //   [{ type: 'CustomerTableData', id: `${data.companyId}-${data.pagination}` }],
      }),
    }),
    updateCustomerDelegation: builder.mutation({
      query: ({ token, data, isDelete }) => ({
        url: isDelete ? DELETE_UPDATE_CUSTOMER_DELEGATION : ADD_CUSTOMER_DELEGATION,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
        invalidatesTags: ["CustomerTableData"],
        // invalidatesTags: (result, error, { data }) =>
        //   [{ type: 'CustomerTableData', id: `${data.companyId}-${data.pagination}` }],
      }),
    }),
  }),
});

export const {
  useFetchAllCustomerValuesQuery,
  useFetchAllDeleteReasonsQuery,
  useUpdateDeleteOrArchiveMutation,
  useFetchCustomerValuesTrackingQuery,
  useFetchCustomerTableDataMutation,
  useFetchCustomerTableDataNewMutation,
  useUpdateCustomerTableDataMutation,
  useUpdateCustomerTableDataNodeMutation,
  useUpdateCustomerDelegationMutation,
} = customerTableShowUpdate;

export const customerTableDropAdd = createApi({
  reducerPath: "customerTableDropAdd",
  baseQuery: customBaseQuery,
  tagTypes: ["customerTableDropData"],
  endpoints: (builder) => ({
    // fetchCustomerTable: builder.query({
    //   query: ({token,data}) => ({
    //     url : `${CUSTOMER_TABLEDYNAMIC_DROP}/${data}`,
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //       'Content-Type': 'application/json',
    //     },
    //     providesTags: ['customerTableDropData'],
    //   })
    // }),
    CustomerTableNode: builder.query({
      query: ({ token, orgId, companyId, fieldName }) => ({
        url: `${CUSTOMER_TABLEDYNAMIC_DROP_NODE}?org_id=${orgId}&company_id=${companyId}&field_name=${fieldName}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["customerTableDropData"],
    }),
    CustomerTable: builder.mutation({
      query: ({ token, data }) => ({
        url: `${CUSTOMER_TABLEDYNAMIC_DROP}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        invalidatesTags: ["customerTableDropData"],
      }),
    }),
    CustomerEdit: builder.mutation({
      query: ({ token, payload }) => ({
        url: `${UPDATE_CUSTOMER_DATA}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: {
          ...payload,
        },
      }),
    }),
    fetchPersonInTable: builder.query({
      query: ({ token, data = "", companyId }) => ({
        url: `${CUSTOMER_PERSON_IN_TABLE}${getCompanyId()}?search=${data}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        providesTags: ["customerTableDropData"],
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    fetchPersonAllInOrg: builder.query({
      query: ({ token, data = "" }) => ({
        url: `${CUSTOMER_ALL_PERSON_IN_ORG}?search=${data}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        providesTags: ["customerTableDropData"],
      }),
    }),

    CustomerTableDropAdd: builder.mutation({
      query: ({ token, data }) => ({
        url: ADD_UPDATE_DROPDOWN,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
        invalidatesTags: ["customerTableDropData"],
      }),
    }),
    deleteCustomerData: builder.mutation({
      query: ({ payload }) => {
        const token = JSON.parse(localStorage.getItem("myUserData")).token;
        return {
          url: DELETE_CUSTOMER_DATA,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: {
            ...payload,
          },
        };
      },
    }),
  }),
});
export const {
  // useLazyFetchCustomerTableQuery,
  useCustomerTableNodeQuery,
  useLazyCustomerTableNodeQuery,
  useCustomerTableMutation,
  useLazyFetchPersonInTableQuery,
  useFetchPersonInTableQuery,
  useCustomerTableDropAddMutation,
  useLazyFetchPersonAllInOrgQuery,
  useDeleteCustomerDataMutation,
  useCustomerEditMutation,
} = customerTableDropAdd;

export const randomUser = createApi({
  reducerPath: "randomUser",
  baseQuery: customBaseQuery,
  tagTypes: ["randomUserData"],
  endpoints: (builder) => ({
    fetchRandomUser: builder.query({
      query: ({ token, data }) => ({
        url: `${RANDOM_PERSON}?search=${data}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        providesTags: ["randomUserData"],
      }),
    }),
  }),
});

export const { useLazyFetchRandomUserQuery } = randomUser;

export const custTableHeadFieldDynAddUp = createApi({
  reducerPath: "custTableHeadFieldDynAddUp",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    CustTableHeadFieldDyn: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMER_OTHERDETAIL_DYNAMIC_ADD_UPDATE,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const { useCustTableHeadFieldDynMutation } = custTableHeadFieldDynAddUp;

export const custTableAddFieldHeader = createApi({
  reducerPath: "custTableAddFieldHeader",
  baseQuery: customBaseQuery,
  tagTypes: ["CustomerTableData"],
  endpoints: (builder) => ({
    CustTableAddFieldHeader: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMERTABLE_ADDFIELD_HEADERS,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
    CustTableUpdateFieldHeader: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMERTABLE_UPDATEFIELD_HEADERS,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
    fetchCustFieldHdr: builder.query({
      query: ({ token, data }) => ({
        url: `${CUSTOMERTABLE_GETFIELD_HEADERS}/${data.id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        tagTypes: ["CustomerTableData"],
      }),
    }),
  }),
});

export const {
  useLazyFetchCustFieldHdrQuery,
  useCustTableAddFieldHeaderMutation,
  useCustTableUpdateFieldHeaderMutation,
} = custTableAddFieldHeader;

export const companyPermissionsData = createApi({
  reducerPath: "companyPermissionsData",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchCompanyPermissions: builder.query({
      query: ({ token, data, companyId }) => ({
        url: `${GET_PERMISSION_COMPANY}/${companyId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["CompanyPermissions"],
      keepUnusedDataFor: 0, // Disable caching
      refetchOnMountOrArgChange: true, // Refetch on mount or arg change
      // skip: (arg) => !arg.token,
    }),
  }),
});

export const { useLazyFetchCompanyPermissionsQuery } = companyPermissionsData;
